import React from 'react'
import PropTypes from 'prop-types'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Dialog, AppBar, Toolbar, IconButton } from '@mui/material'
import { t } from 'i18next'
import {
  trackingIframeUrlsByCompany,
  TRACKING_IFRAME_SANDBOX,
} from 'Utils/constants'
import './OrderTrackingModal.css'
export default function OrderTrackingModal({
  open,
  onClose,
  companyID,
  invoiceNumber,
  trackingUrl,
}) {
  const baseUrlTracking = trackingIframeUrlsByCompany[companyID?.toUpperCase()]

  // Validar que sea una URL válida
  const isValidUrl =
    baseUrlTracking &&
    typeof baseUrlTracking === 'string' &&
    (baseUrlTracking.startsWith('http://') ||
      baseUrlTracking.startsWith('https://'))

  // Validar que existe URL válida y número de factura
  const isValidTracking = isValidUrl && invoiceNumber
  const orderUrlTracking = isValidTracking
    ? `${baseUrlTracking}/orders/${invoiceNumber}`
    : null

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      className="modal-tracking-wrapper"
      data-testid="modal-order-tracking">
      <AppBar
        className="app-bar-modal-tracking"
        data-testid="container-tracking-appbar">
        <Toolbar>
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
            className="icon-close-btn-tracking"
            data-testid="btn-close-tracking-modal">
            <CloseIcon className="close-icon-modal-tracking" />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box
        className="iframe-tracking-container"
        style={{ marginLeft: 'var(--padding-left-bar)' }}
        data-testid="container-tracking-content">
        {isValidTracking && orderUrlTracking ? (
          <iframe
            title={t('DISPATCH_ORDER_T.ORDER_TRACKING')}
            src={orderUrlTracking}
            className="iframe-tracking-element"
            sandbox={TRACKING_IFRAME_SANDBOX}
            data-testid="iframe-tracking"
          />
        ) : (
          <Box
            className="tracking-unavailable-message"
            data-testid="container-tracking-unavailable">
            <h2 className="title" data-testid="text-tracking-unavailable-title">
              Tracking no disponible
            </h2>
            <p
              className="description"
              data-testid="text-tracking-unavailable-description">
              No se encontró configuración de tracking para este despacho
            </p>
          </Box>
        )}
      </Box>
    </Dialog>
  )
}

OrderTrackingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  companyID: PropTypes.string.isRequired,
  invoiceNumber: PropTypes.string,
}
